import {
  ActionType,
  AutoTextField,
  DatePickerField,
  RadioGroupField,
  SelectAutocompleteField,
  SelectField,
} from '../../components/AutoForm/AutoFieldNew';
import {countriesList} from '../../utils/countries';

export type LeadFormPersonValues = {
  contactId: string;
  dob: string;
  firstName: string;
  middleName: string;
  homePhone: string;
  jobTitle: string;
  lastName: string;
  linkedinProfile: string;
  mobilePhone: string;
  nationalInsurance: string;
  primaryEmail: string;
  secondaryEmail: string;
  title: string;
  contactError: string;
  nationality: string;
  taxResidency: string;
  taxDomicile: string;
  knownAs: string;
};
export type LeadAddress = {
  line1: string;
  line2: string;
  line3: string;
  city: string;
  postcode: string;
  county: string;
  country: string;
  moveInDate: Date;
};

export type LeadFormValues = LeadAddress & {
  accountId: string;
  accountName: string;
  accountType: 'Household' | 'Trust' | 'Corporate' | 'Pension scheme';
  adviser: string;
  relatedLeadId: string;
  leadId: string;
  leadSource: string;
  primary: LeadFormPersonValues;
  secondary: LeadFormPersonValues;
  singleJoint: 'single' | 'joint' | '';
  initialOrFixedFeeField: 'initialPercentageFee' | 'initialFixedFee' | 'initialNoFee';
  initialFixedFee?: string;
  initialPercentageFee?: string;
  ongoingFee: string;
  // Trust
  trustStartDate: string;
  trustType: string;
  // Company
  businessUnitId: string;
  companyNumber: string;
  companyName: string;
  agree: boolean;
};
export const leadTypeField: SelectField = {
  id: 'accountType',
  label: 'Account type *',
  type: ActionType.select,
  options: [
    {
      label: 'Household',
      value: 'Household',
    },
    {
      label: 'Trust',
      value: 'Trust',
    },
    {
      label: 'Corporate',
      value: 'Corporate',
    },
    {
      label: 'Pension scheme',
      value: 'Pension scheme',
    },
  ],
};
export const singleJointField: SelectField = {
  id: 'singleJoint',
  label: 'Account type *',
  type: ActionType.select,
  options: [
    {
      label: 'Single',
      value: 'single',
    },
    {
      label: 'Joint',
      value: 'joint',
    },
  ],
};

export const titleField: SelectAutocompleteField = {
  id: 'title',
  label: 'Title *',
  type: ActionType.selectAutocomplete,
  options: [
    {
      label: 'Mr',
      value: 'Mr',
      group: 'Common',
    },
    {
      label: 'Mrs',
      value: 'Mrs',
      group: 'Common',
    },
    {
      label: 'Miss',
      value: 'Miss',
      group: 'Common',
    },
    {
      label: 'Ms',
      value: 'Ms',
      group: 'Common',
    },
    {
      label: 'Master',
      value: 'Master',
      group: 'Common',
    },
    {
      label: 'Dr',
      value: 'Dr',
      group: 'Common',
    },
    {
      label: 'Professor',
      value: 'Professor',
      group: 'Common',
    },
    {
      label: 'Reverend',
      value: 'Reverend',
      group: 'Common',
    },
    {
      label: 'Lord',
      value: 'Lord',
      group: 'Common',
    },
    {
      label: 'Lady',
      value: 'Lady',
      group: 'Common',
    },

    {
      label: 'Mx',
      value: 'Mx',
      group: 'Other',
    },
    {
      label: 'Advocate',
      value: 'Advocate',
      group: 'Other',
    },
    {
      label: 'Baron',
      value: 'Baron',
      group: 'Other',
    },
    {
      label: 'Baroness',
      value: 'Baroness',
      group: 'Other',
    },
    {
      label: 'Bishop',
      value: 'Bishop',
      group: 'Other',
    },
    {
      label: 'Brigadier',
      value: 'Brigadier',
      group: 'Other',
    },
    {
      label: 'Canon',
      value: 'Canon',
      group: 'Other',
    },
    {
      label: 'Captain',
      value: 'Captain',
      group: 'Other',
    },
    {
      label: 'Colonel',
      value: 'Colonel',
      group: 'Other',
    },
    {
      label: 'Commander',
      value: 'Commander',
      group: 'Other',
    },
    {
      label: 'The Countess of',
      value: 'The Countess of',
      group: 'Other',
    },
    {
      label: 'Dame',
      value: 'Dame',
      group: 'Other',
    },
    {
      label: 'Father',
      value: 'Father',
      group: 'Other',
    },
    {
      label: 'Group Captain',
      value: 'Group Captain',
      group: 'Other',
    },
    {
      label: 'His Honour',
      value: 'His Honour',
      group: 'Other',
    },
    {
      label: 'Hon Mrs',
      value: 'Hon Mrs',
      group: 'Other',
    },
    {
      label: 'The Hon Mrs',
      value: 'The Hon Mrs',
      group: 'Other',
    },
    {
      label: 'Honourable',
      value: 'Honourable',
      group: 'Other',
    },
    {
      label: 'The Honourable',
      value: 'The Honourable',
      group: 'Other',
    },
    {
      label: 'The Hon.',
      value: 'The Hon.',
      group: 'Other',
    },
    {
      label: 'Judge',
      value: 'Judge',
      group: 'Other',
    },
    {
      label: 'Lady',
      value: 'Lady',
      group: 'Other',
    },
    {
      label: 'Lieutenant',
      value: 'Lieutenant',
      group: 'Other',
    },
    {
      label: 'Lieutenant Colonel',
      value: 'Lieutenant Colonel',
      group: 'Other',
    },
    {
      label: 'Major',
      value: 'Major',
      group: 'Other',
    },
    {
      label: 'Maj Gen',
      value: 'Maj Gen',
      group: 'Other',
    },
    {
      label: 'Mother',
      value: 'Mother',
      group: 'Other',
    },
    {
      label: 'Princess',
      value: 'Princess',
      group: 'Other',
    },
    {
      label: 'Prof',
      value: 'Prof',
      group: 'Other',
    },
    {
      label: 'Rabbi',
      value: 'Rabbi',
      group: 'Other',
    },
    {
      label: 'Rev',
      value: 'Rev',
      group: 'Other',
    },
    {
      label: 'Sir',
      value: 'Sir',
      group: 'Other',
    },
    {
      label: 'Sister',
      value: 'Sister',
      group: 'Other',
    },
    {
      label: 'Squadron Leader',
      value: 'Squadron Leader',
      group: 'Other',
    },
    {
      label: 'The Right Hon.',
      value: 'The Right Hon.',
      group: 'Other',
    },
    {
      label: 'Viscount',
      value: 'Viscount',
      group: 'Other',
    },
    {
      label: 'Viscountess',
      value: 'Viscountess',
      group: 'Other',
    },
    {
      label: 'Wing Commander',
      value: 'Wing Commander',
      group: 'Other',
    },
  ],
};
export const firstNameField: AutoTextField = {
  id: 'firstName',
  label: 'First Name *',
  type: ActionType.text,
};

export const middleNameField: AutoTextField = {
  id: 'middleName',
  label: 'Middle Name',
  type: ActionType.text,
};

export const lastNameField: AutoTextField = {
  id: 'lastName',
  label: 'Last Name *',
  type: ActionType.text,
};
export const knownAsField: AutoTextField = {
  id: 'knownAs',
  label: 'Known as',
  type: ActionType.text,
};
export const adviserField: SelectAutocompleteField = {
  id: 'adviser',
  label: 'Adviser *',
  type: ActionType.selectAutocomplete,
  fullWidth: true,
  options: [],
};
export const emailField: AutoTextField = {
  id: 'primaryEmail',
  label: 'Email *',
  type: ActionType.text,
  private: true,
};
export const mobileField: AutoTextField = {
  id: 'mobilePhone',
  label: 'Mobile (tel)',
  type: ActionType.text,
  private: true,
};
const homePhoneField: AutoTextField = {
  id: 'homePhone',
  label: 'Home (tel)',
  type: ActionType.text,
  private: true,
};
export const nationalInsuranceField: AutoTextField = {
  id: 'nationalInsurance',
  label: 'National insurance *',
  type: ActionType.text,
  charLimit: 13,
  private: true,
};
export const nationality: SelectField = {
  id: 'nationality',
  label: 'Nationality *',
  type: ActionType.select,
  options: countriesList,
  private: true,
};

// ADDRESS

export const address1Field: AutoTextField = {
  id: 'line1',
  label: 'Address 1 *',
  type: ActionType.text,
  labelOnTop: true,
};
export const address2Field: AutoTextField = {
  id: 'line2',
  label: 'Address line 2',
  type: ActionType.text,
  labelOnTop: true,
};
export const address3Field: AutoTextField = {
  id: 'line3',
  label: 'Address 3',
  type: ActionType.text,
  labelOnTop: true,
};
export const townField: AutoTextField = {
  id: 'city',
  label: 'Town/City *',
  type: ActionType.text,
  labelOnTop: true,
};
export const postcodeField: AutoTextField = {
  id: 'postcode',
  label: 'Postcode *',
  type: ActionType.text,
  labelOnTop: true,
};
export const county: AutoTextField = {
  id: 'county',
  label: 'County',
  type: ActionType.text,
  labelOnTop: true,
};
export const country: SelectField = {
  id: 'country',
  label: 'Country',
  type: ActionType.select,
  options: countriesList,
};
export const taxResidency: SelectField = {
  id: 'taxResidency',
  label: 'Tax Residency',
  type: ActionType.select,
  options: countriesList,
};
export const taxDomicile: SelectField = {
  id: 'taxDomicile',
  label: 'Tax Domicile',
  type: ActionType.select,
  options: countriesList,
};
export const moveInDateField: DatePickerField = {
  id: 'moveInDate',
  label: 'Move in date (DD/MM/YYYY)',
  type: ActionType.datepicker,
  fullWidth: true,
};

// FEES
export const initialFixedFeeField: AutoTextField = {
  id: 'initialFixedFee',
  label: 'Fixed (£)',
  type: ActionType.text,
  currency: true,
};
export const initialPercentageFeeField: AutoTextField = {
  id: 'initialPercentageFee',
  label: 'Ad valorem (%)',
  type: ActionType.text,
  percent: true,
  decimals: 2,
};

export const initialOrFixedFeeField: RadioGroupField = {
  id: 'initialOrFixedFeeField',
  label: '',
  type: ActionType.radioGroup,
  needsValue: true,
  options: [
    {
      value: 'initialPercentageFee',
      label: 'Ad valorem (%)',
    },
    {
      value: 'initialFixedFee',
      label: 'Fixed (£)',
    },
    {
      value: 'initialNoFee',
      label: 'No fee',
    },
  ],
  initialValue: 'initialFee',
};

// COMPANY
export const companyNameField: AutoTextField = {
  id: 'companyName',
  label: 'Company Name',
  type: ActionType.text,
  fullWidth: true,
};
export const companyNumberField: AutoTextField = {
  id: 'companyNumber',
  label: 'Company Number',
  type: ActionType.text,
  fullWidth: true,
};

// TRUST

const trustTypes = [
  'Accumulation & Maintenance Trust',
  'Bare Trust',
  'Charitable Trust',
  'Deputyship',
  'Discretionary Trust',
  'Interest in Possession Trust',
  'Loan Trust',
  'Mixed Trust',
  'Non-Resident Trust',
  'Parental trust',
  'Pension Death Benefit Trust',
  'Settlor Interested Trust',
  'Vulnerable Beneficiaries Trust',
  'Will Trust',
  'Disabled Trust',
  'Estate',
] as const;

export const trustTypeField: SelectField = {
  id: 'trustType',
  label: 'Trust Type',
  type: ActionType.select,
  options: trustTypes.map((x) => ({value: x, label: x})),
  fullWidth: true,
};

export const trustStartDateField: DatePickerField = {
  id: 'trustStartDate',
  label: 'Trust Start Date (DD/MM/YYYY)',
  type: ActionType.datepicker,
  fullWidth: true,
};
